export default "__VITE_ASSET__C9gG1sw8__"